// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-title[data-v-0c28ac26] {\n  height: 50px;\n}\n.item-text1[data-v-0c28ac26] {\n  font-weight: bold;\n}\n[data-v-0c28ac26] .el-drawer__header {\n  margin-bottom: 10px;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n", ""]);
// Exports
module.exports = exports;
